import reportBg from "../../../assets/final.jpg"; // Import the background image

const BackPage = () => {
  return (
    <section
      className="pdf-page relative flex flex-col justify-between p-[60px_40px] text-white"
      style={{
        backgroundImage: `url(${reportBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
      }}
    ></section>
  );
};

export default BackPage;
